// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_F19","badges":"styles_badges__1zo0a"};